import { background, icon, reference } from '@carvana/ds-styles';
import type { Brand } from '../brand';

interface BrandTokens {
  /** Icon colour for a completed or confirmed state. Slate has no success green. */
  completeIcon: string;
  emphasisIcon: string;
  disclosureIcon: string;
  heroAccentFill: string;
  promoAccentFill: string;
  /**
   * The two brands supply opposite halves of these DS chip props. Slate has no semantic
   * chip colours, so it pins `custom` plus its own background/foreground and leaves
   * `chipVariant` undefined for the DS default; Carvana sets only `chipVariant`, leaving
   * the other three undefined so the call site keeps its own semantic priority.
   */
  chipPriority: 'custom' | undefined;
  chipBackground: string | undefined;
  chipForeground: string | undefined;
  chipVariant: 'outline' | undefined;
}

const BRAND_TOKENS: Record<Brand, BrandTokens> = {
  carvana: {
    completeIcon: icon.success,
    emphasisIcon: icon.strong,
    disclosureIcon: icon.default,
    heroAccentFill: reference.blue['600'],
    promoAccentFill: reference.blue['600'],
    chipPriority: undefined,
    chipBackground: undefined,
    chipForeground: undefined,
    chipVariant: 'outline'
  },
  slate: {
    completeIcon: icon.primary,
    emphasisIcon: icon.primary,
    disclosureIcon: icon.primary,
    heroAccentFill: reference.silver['300'],
    promoAccentFill: reference.silver['200'],
    chipPriority: 'custom',
    chipBackground: background.medium,
    chipForeground: reference.other.white,
    chipVariant: undefined
  }
};

export { BRAND_TOKENS };
export type { BrandTokens };
